export default "/images/a519fe129a67012608bd2f443c48941b.avif";